"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import {PageEnConstruction} from "@/components/common/page-en-construction";

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"La Disponibilité des Hébergements Restaurants et Maquis"}
                                middleBreadcrumbs={[{title: "L’Office et Vous", link: "/espace-pro/office-et-vous"}]}
                                description={"Découvrez les missions et la vision de cette structure dotée de ressources importantes au cœur de l’écosystème touristique ivoirien."} />

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">

               <PageEnConstruction />
            </SectionPage>

        </div>
    );
}
